function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H32V32H0z",
  transform: "translate(-1049 -80) translate(0 64) translate(1049 16)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M12.19.381H2.286C1.236.381.38 1.235.38 2.286v11.428c0 1.051.855 1.905 1.905 1.905h9.904c1.05 0 1.905-.854 1.905-1.905V2.286c0-1.051-.855-1.905-1.905-1.905zm-4.952.762h2.286v2.812l-.972-.487c-.108-.053-.234-.053-.341 0l-.973.487V1.143zM1.143 13.714V2.286c0-.63.513-1.143 1.143-1.143h.38v13.714h-.38c-.63 0-1.143-.513-1.143-1.143zm12.19 0c0 .63-.512 1.143-1.143 1.143H3.43V1.143h3.047V4.57c0 .132.069.255.18.325.112.068.253.075.371.016l1.354-.677 1.353.678c.054.026.112.04.17.04.07 0 .14-.02.201-.057.112-.07.18-.193.18-.325V1.143h1.905c.63 0 1.143.513 1.143 1.143v11.428z",
  transform: "translate(-1049 -80) translate(0 64) translate(1049 16) translate(9 8)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.667 10.286H5.333c-.21 0-.38.17-.38.38 0 .211.17.382.38.382h5.334c.21 0 .38-.171.38-.381s-.17-.381-.38-.381zM10.667 12.571H5.333c-.21 0-.38.171-.38.381s.17.381.38.381h5.334c.21 0 .38-.17.38-.38s-.17-.382-.38-.382z",
  transform: "translate(-1049 -80) translate(0 64) translate(1049 16) translate(9 8)"
})))))));

var SvgAudit = function SvgAudit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAudit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audit.d3758b47.svg";
export { ForwardRef as ReactComponent };